module.exports = __webpack_public_path__ + "media/src/images/drag_light-1dfe8058dca33b463a149f911c3e4b01.png";